import { AppointmentType } from '../schedule-preview/types';
import { useInSessionAppointment } from './useInSessionAppointment';

export function useIsIntakeAppointment() {
  const appointment = useInSessionAppointment();
  return appointment?.appointmentType === AppointmentType.Intake;
}
